/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Resource } from '@ngxp/rest';
import { first, Observable, switchMap } from 'rxjs';
import { StateService } from '../ngrx/state.service';
import { ListResourceService } from './list-resource.service';
import { ListItemResource, ListResourceServiceConfig } from './resource.model';
import { ListResource, StateResource } from './resource.util';

export class ApiListResourceService<
  B extends Resource,
  T extends ListResource,
  I extends ListItemResource,
> extends ListResourceService<B, T, I> {
  constructor(
    protected config: ListResourceServiceConfig<B>,
    protected oldStateService?: StateService,
  ) {
    super(config);
  }

  public create(toCreate: unknown): Observable<StateResource<I>> {
    return this.selectListResource().pipe(
      first(),
      switchMap((listResource: T) =>
        this.resourceStateService.create<I>({ resource: listResource, linkRel: this.config.create.linkRel, toCreate }),
      ),
    );
  }
}
